module.exports = __webpack_public_path__ + "media/images/company-pic-7d4a58ff848ba5dedd2fab65a0211abb.svg";